var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 3.125C6.75 3.47018 6.47018 3.75 6.125 3.75C5.77982 3.75 5.5 3.47018 5.5 3.125C5.5 2.77982 5.77982 2.5 6.125 2.5C6.47018 2.5 6.75 2.77982 6.75 3.125ZM6.75 5.625C6.75 5.97018 6.47018 6.25 6.125 6.25C5.77982 6.25 5.5 5.97018 5.5 5.625C5.5 5.27982 5.77982 5 6.125 5C6.47018 5 6.75 5.27982 6.75 5.625ZM6.125 8.75C6.47018 8.75 6.75 8.47018 6.75 8.125C6.75 7.77982 6.47018 7.5 6.125 7.5C5.77982 7.5 5.5 7.77982 5.5 8.125C5.5 8.47018 5.77982 8.75 6.125 8.75Z",
    fill: "#FFBE1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDots);
export default __webpack_public_path__ + "static/media/vertical-dots.9244e90b2477d5c2f26a3453689cdca1.svg";
export { ForwardRef as ReactComponent };